/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShiftCalendarViewModel } from '../../models/shift-calendar-view-model';

export interface GetShiftCalendars$Params {
}

export function getShiftCalendars(http: HttpClient, rootUrl: string, params?: GetShiftCalendars$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShiftCalendarViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getShiftCalendars.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShiftCalendarViewModel>>;
    })
  );
}

getShiftCalendars.PATH = '/api/v1/WorkCenter/GetShiftCalendars';
